"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeDifTranslations = exports.TimeDifPlugin = void 0;
const hyperformula_1 = require("hyperformula");
const moment_1 = __importDefault(require("moment"));
class TimeDifPlugin extends hyperformula_1.FunctionPlugin {
    timedif(ast, state) {
        return this.runFunction(ast.args, state, this.metadata('TIMEDIF'), (firstDate, secondDate) => {
            const { result } = this.hoursDiff(firstDate, secondDate);
            return result;
        });
    }
    hoursDiff(timeStart, timeEnd) {
        if (!timeStart || !timeEnd) {
            return { result: Number('0.00') };
        }
        const { start, end } = this.getParsedDateAndTime(timeStart, timeEnd);
        // eg. shift starts at 8pm ends at 4am
        if (start > end) {
            start.subtract(1, 'day');
        }
        const hours = (0, moment_1.default)(end).diff(start, 'hours', true);
        return { result: Number(Math.abs(hours).toFixed(2)) };
    }
    getParsedDateAndTime(timeStart, timeEnd) {
        const startSimpleDateTime = this.dateTimeHelper.numberToSimpleDateTime(timeStart);
        const endSimpleDateTime = this.dateTimeHelper.numberToSimpleDateTime(timeEnd);
        return {
            start: (0, moment_1.default)(Object.assign(Object.assign({}, startSimpleDateTime), { month: startSimpleDateTime.month - 1 })),
            end: (0, moment_1.default)(Object.assign(Object.assign({}, endSimpleDateTime), { month: endSimpleDateTime.month - 1 })),
        };
    }
}
exports.TimeDifPlugin = TimeDifPlugin;
TimeDifPlugin.implementedFunctions = {
    TIMEDIF: {
        method: 'timedif',
        parameters: [{ argumentType: 'STRING' }, { argumentType: 'STRING' }],
    },
};
exports.TimeDifTranslations = {
    enGB: {
        TIMEDIF: 'TIMEDIF',
    },
};
